import { useCallback, useState } from 'react'
import { assistantModelOptions, changeAssistantProvider } from './assistantProviderChoices'
import { GeneratedActions, GeneratedRecord } from './GeneratedNativeView'
import { buildEntityFieldMeta } from './entityFieldMeta'
import type { FetchEntityOptions } from './ViewRenderer'
import type { ViewDefinition } from './viewTypes'
import entity from '../../../../../docs/specs/platform-views/source/entities/ralph-provider-profile.json'
import definition from '../../../../../docs/specs/platform-views/source/views/ralph-provider-profile.view.json'

export interface AssistantProfileValue { id: string; name: string; revision: number; enabled: boolean;
    definition: { adapter: string; model: string; endpoint: string; maxOutputTokens: number } }
const fields = buildEntityFieldMeta([{ key: entity.entity, fields: entity.fields }])
const permissions = new Set<string>()
export function AssistantProfileEditor({ profile, pending, onSave }: {
    profile: AssistantProfileValue; pending: boolean; onSave: (profile: AssistantProfileValue, secret: string | null) => Promise<void>
}) {
    const [draft, setDraft] = useState<Record<string, unknown>>({ ...profile, ...profile.definition, secret: '' })
    const modelOptions = useCallback<FetchEntityOptions>(async (_source, _display, _value, _filter, _company, search) =>
        assistantModelOptions(String(draft.adapter), String(draft.model ?? '')).filter(option => !search || option.label.toLowerCase().includes(search.toLowerCase())), [draft.adapter, draft.model])
    const modelLabel = useCallback(async (_entity: string, _display: string | undefined, value: string) => value, [])
    async function save() {
        const secret = typeof draft.secret === 'string' && draft.secret ? draft.secret : null
        setDraft(current => ({ ...current, secret: '' }))
        await onSave({ id: profile.id, revision: profile.revision, name: String(draft.name ?? ''), enabled: draft.enabled === true,
            definition: { adapter: String(draft.adapter), model: String(draft.model ?? ''), endpoint: String(draft.endpoint ?? ''), maxOutputTokens: Number(draft.maxOutputTokens) } }, secret)
    }
    return <>
        <GeneratedRecord view={definition as unknown as ViewDefinition} fields={fields} record={draft}
            fetchEntityOptions={modelOptions} fetchEntityById={modelLabel}
            onChange={pending ? undefined : next => setDraft(previous => changeAssistantProvider(previous, next))} />
        <GeneratedActions view={definition as unknown as ViewDefinition} record={draft} permissions={permissions} pending={pending} onAction={() => { void save() }} />
    </>
}
